function filterPriceBookRows(items: Array<Record<string, unknown>>, serviceItemIds: string[]): Array<Record<string, unknown>> {
  if (serviceItemIds.length === 0) {
    return items;
  }

  const allowed = new Set(serviceItemIds.map(String));
  return items.filter((row) => allowed.has(String(row.id ?? '')));
}

/**
 * Applies template serviceItemIds filtering without hiding live CRM rows when ids are stale.
 */
export function resolvePriceBookRowsForBlock(
  priceBookRows: Array<Record<string, unknown>>,
  serviceItemIds: string[] | undefined
): Array<Record<string, unknown>> {
  const ids = serviceItemIds ?? [];
  if (ids.length === 0) {
    return priceBookRows;
  }

  const filtered = filterPriceBookRows(priceBookRows, ids);
  return filtered.length > 0 ? filtered : priceBookRows;
}
